/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Quick_Lark_RiseInputs */

const fr_odd_quick_lark_rise = /** @type {(inputs: Odd_Quick_Lark_RiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors du chargement du calendrier.`)
};

/**

* @param {Odd_Quick_Lark_RiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const odd_quick_lark_rise = /** @type {((inputs?: Odd_Quick_Lark_RiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Quick_Lark_RiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_odd_quick_lark_rise(inputs)
});